import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import MediaUpload from '~/components/common/media-upload';
import Icon from '~/components/common/icon';

/**
 * Render Matrix Sorting Question Type
 *
 * @callback handleAnswerUpdate
 * @callback handleAnswerRemove
 * @callback handleCheckboxChange
 * @callback handleInputChange
 * @callback handleShowForm
 * @callback handleAddMedia
 * @param {Object} props
 * @param {handleAnswerUpdate} props.handleAnswerUpdate
 * @param {handleAnswerRemove} props.handleAnswerRemove
 * @param {handleCheckboxChange} props.handleCheckboxChange
 * @param {handleInputChange} props.handleInputChange
 * @param {handleShowForm} props.handleShowForm
 * @param {handleAddMedia} props.handleAddMedia
 * @param {boolean} props.showFormIndividual
 * @param {string} props.answer
 * @param {boolean} props.html
 * @param {string} props.sortString
 * @param {boolean} props.sortStringHtml
 */
const QuestionTypeMatrix = ( {
	handleAnswerUpdate,
	handleAnswerRemove,
	handleCheckboxChange,
	handleInputChange,
	handleShowForm,
	handleAddMedia,
	showFormIndividual,
	answer,
	html,
	sortString,
	sortStringHtml,
} ) => (
	<Fragment>
		<span className="ld__builder-row-type -child sfwd-answer">A</span>
		{ ! showFormIndividual && (
			<button
				onClick={ handleShowForm }
				className="ld-button-reset ld-button-matrix-edit"
			>
				<span
					className="ld-answer-value"
					dangerouslySetInnerHTML={ {
						__html:
							'' === answer
								? `${ LearnDashData.i18n.edit_matrix }`
								: answer,
					} }
				/>
				{ '' !== sortString ? <Icon icon="chevron-right" /> : '' }
				<span
					className="ld-answer-value"
					dangerouslySetInnerHTML={ { __html: sortString } }
				/>
				<span className="edit">
					<Icon icon="pencil" />
					<span className="screen-reader-text">{ `${ LearnDashData.i18n.edit }` }</span>
				</span>
			</button>
		) }
		{ showFormIndividual && (
			<div className="ld-answer-editor">
				<div className="ld-answer-editor-table">
					<div>
						<textarea
							name="answer"
							value={ answer }
							onChange={ handleInputChange }
							autoFocus
						/>
						<div className="ld-answer-editor-actions -matrix">
							<label className="ld-switch-wrapper html">
								<span className="ld-switch">
									<input
										type="checkbox"
										name="html"
										checked={ html }
										onChange={ handleCheckboxChange }
										className="ld-switch__input"
									/>
									<span className="ld-switch__track" />
									<span className="ld-switch__thumb" />
									<span className="ld-switch__on-off" />
								</span>
								<span className="label-text">{ `${ LearnDashData.i18n.allow_html }` }</span>
							</label>

							<MediaUpload onSelect={ handleAddMedia } />
						</div>
						<Icon icon="chevron-right" />
					</div>
					<div>
						<textarea
							name="sortString"
							value={ sortString }
							onChange={ handleInputChange }
						/>
						<div className="ld-answer-editor-actions -matrix">
							<label className="ld-switch-wrapper html">
								<span className="ld-switch">
									<input
										type="checkbox"
										name="sortStringHtml"
										checked={ sortStringHtml }
										onChange={ handleCheckboxChange }
										className="ld-switch__input"
									/>
									<span className="ld-switch__track" />
									<span className="ld-switch__thumb" />
									<span className="ld-switch__on-off" />
								</span>
								<span className="label-text">{ `${ LearnDashData.i18n.allow_html }` }</span>
							</label>
						</div>
					</div>
				</div>

				<div className="ld-answer-editor-actions">
					<button
						className="is-button is-primary"
						onClick={ handleAnswerUpdate }
					>{ `${ LearnDashData.i18n.update_answer }` }</button>

					<span className="ld-trash">
						<button
							className="is-button components-button is-default"
							onClick={ handleShowForm }
						>{ `${ LearnDashData.i18n.cancel }` }</button>
					</span>
				</div>
			</div>
		) }
		<div className="row-actions -right">
			<span className="trash">
				<a
					href="#"
					className="submitdelete"
					onClick={ handleAnswerRemove }
				>{ `${ LearnDashData.i18n.remove }` }</a>
			</span>
		</div>
	</Fragment>
);

/**
 * Valid props
 */
QuestionTypeMatrix.propTypes = {
	handleAnswerUpdate: PropTypes.func,
	handleAnswerRemove: PropTypes.func,
	handleCheckboxChange: PropTypes.func,
	handleInputChange: PropTypes.func,
	handleShowForm: PropTypes.func,
	handleAddMedia: PropTypes.func,
	showFormIndividual: PropTypes.bool,
	answer: PropTypes.string,
	html: PropTypes.bool,
	sortString: PropTypes.string,
	sortStringHtml: PropTypes.bool,
};

export default QuestionTypeMatrix;
